import { useEffect, useState } from "react";

const KEY = "gb_intro_seen";
const LOGO = "/glowbit-logo.webp";

function shouldShow() {
  try {
    if (sessionStorage.getItem(KEY)) return false;
    sessionStorage.setItem(KEY, "1");
  } catch {
    return false;
  }
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return false;
  return ["/", "/platform/login"].includes(window.location.pathname);
}

const SHOW_ON_LOAD = shouldShow();

// Breve intro grafica: una sola volta per scheda, solo sull'accesso.
export function IntroSplash() {
  const [phase, setPhase] = useState(SHOW_ON_LOAD ? "in" : "done");

  useEffect(() => {
    if (phase === "done") return undefined;
    const t1 = setTimeout(() => setPhase("fade"), 800);
    const t2 = setTimeout(() => setPhase("out"), 1000);
    const t3 = setTimeout(() => setPhase("done"), 1220);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [phase === "done"]); // eslint-disable-line react-hooks/exhaustive-deps

  if (phase === "done") return null;
  return (
    <div data-testid="intro-splash" aria-hidden="true"
      className={`gb-splash fixed inset-0 z-[9999] flex flex-col items-center justify-center ${phase === "fade" ? "gb-splash-fade" : ""} ${phase === "out" ? "gb-splash-fade gb-splash-out" : ""}`}
      style={{ background: "linear-gradient(135deg, var(--brand-dark) 0%, #2d1526 100%)" }}>
      <div className="gb-splash-logo rounded-full shadow-lg flex items-center justify-center overflow-hidden h-36 w-36 sm:h-40 sm:w-40"
        style={{ background: "#F8EEF1" }}>
        <img src={LOGO} alt="" width="480" height="442" decoding="async"
          className="max-w-[70%] max-h-[70%] w-auto h-auto object-contain"
          onError={(e) => { e.currentTarget.style.visibility = "hidden"; }} />
      </div>
      <div className="mt-8 h-px w-[170px] overflow-hidden rounded-full" style={{ background: "rgba(255,255,255,0.18)" }}>
        <div data-testid="intro-splash-bar" className="gb-splash-bar h-full w-full bg-white" />
      </div>
    </div>
  );
}
